module.exports = __webpack_public_path__ + "img/short_answer.df7873a1.svg";